module.exports = __webpack_public_path__ + "static/media/make-your-own-handwritten.12d28f73.png";